import React from 'react';
import { useAuth } from '../../context/AuthContext';

interface HeaderProps {
  title: string;
}

export const Header: React.FC<HeaderProps> = ({ title }) => {
  const { user, signOut } = useAuth();

  const handleLogout = async () => {
    if (confirm('Tem certeza que deseja sair?')) {
      try {
        await signOut();
      } catch (error) {
        console.error('Error signing out:', error);
      }
    }
  };

  return (
    <header className="top-bar">
      <h1 id="page-title">{title}</h1>
      <div className="user-info">
        <span className="notification-badge">
          <i className="ti ti-bell" aria-hidden="true"></i>
          <span className="badge">3</span>
        </span>
        <div className="user-info-text">
          <span id="current-user">{user?.email || 'Admin'}</span>
        </div>
        <button className="btn-logout" onClick={handleLogout} title="Sair">
          <i className="ti ti-logout" aria-hidden="true"></i>
        </button>
      </div>
    </header>
  );
};